/*global AmCharts, App */

Components.Energy.Common.BaseCompareChartWithTable = function (container, stocks, tableContainer) {
    /* private */
    var _chart;
    var zoomOut = function() {
        try {
            _chart.zoomOut();
        } catch (e) {
        }
    };

    var _stocks = stocks;
    var _container = container;

    var createChart = function () {
        var chart = new AmCharts.AmStockChart();
        chart.language = "cz";
        chart.pathToImages = "/dist/amcharts/images/";
        chart.export = true;

        for (var i in _stocks) {
            i = parseInt(i);
            var panelDefinitions = _stocks[i];
            var stockPanel = createChartPanel(panelDefinitions);
            chart.addPanel(stockPanel);
        }

        var panelsSettings = new AmCharts.PanelsSettings();
        panelsSettings.marginLeft = 60;
        panelsSettings.marginBottom = 5;
        chart.panelsSettings = panelsSettings;

        var valueAxesSettings = new AmCharts.ValueAxesSettings();
        valueAxesSettings.inside = false;
        chart.valueAxesSettings = valueAxesSettings;

        var categoryAxesSettings = new AmCharts.CategoryAxesSettings();
        categoryAxesSettings.groupToPeriods = ["1mm","5mm", "15mm", "hh", "6hh", "12hh", "DD", "MM", "YYYY"];
        categoryAxesSettings.minPeriod = "1mm";
        chart.categoryAxesSettings = categoryAxesSettings;

        var cursorSettings = new AmCharts.ChartCursorSettings();
        cursorSettings.categoryBalloonEnabled = true;
        cursorSettings.cursorAlpha = 0.05;
        cursorSettings.fullWidth = true;
        cursorSettings.valueBalloonsEnabled = false;
        chart.chartCursorSettings = cursorSettings;

        var scrollbarSettings = new AmCharts.ChartScrollbarSettings();
        scrollbarSettings.enabled = true;
        scrollbarSettings.graph = "g0";
        scrollbarSettings.position = "bottom";
        scrollbarSettings.updateOnReleaseOnly = true;
        scrollbarSettings.usePeriod = "1mm";
        chart.chartScrollbarSettings = scrollbarSettings;


        chart.addListener("dataUpdated", function() {
            setTimeout(zoomOut, 250);
        });

        return chart;
    };
    var createChartPanel = function(panelDefinitions) {
        var stockPanel = new AmCharts.StockPanel();
        stockPanel.id = panelDefinitions.valueName;
        stockPanel.title = panelDefinitions.title;
        stockPanel.showCategoryAxis = true;
        stockPanel.percentHeight = 25;
        stockPanel.recalculateToPercents = "never";
        stockPanel.usePrefixes = true;
        var valueAxis = new AmCharts.ValueAxis();

        valueAxis.unit = panelDefinitions.unit;
        if ("guides" in panelDefinitions) {
            for (var guideIndex in panelDefinitions.guides) {
                var guideDefinition = panelDefinitions.guides[guideIndex];
                var guide = new AmCharts.Guide();
                guide.fillAlpha = guideDefinition.fillAlpha;
                guide.fillColor = guideDefinition.fillColor;
                guide.lineAlpha = guideDefinition.lineAlpha;
                guide.toValue = guideDefinition.toValue;
                guide.value = guideDefinition.value;
                valueAxis.guides.push(guide);
            }
        }
        stockPanel.addValueAxis(valueAxis);

        stockPanel.stockLegend = {
            valueTextRegular: "[[value]]" + panelDefinitions.unit,
            periodValueTextComparing: "[[value]]" + panelDefinitions.unit
        };
        for (var i in panelDefinitions.graphDefinitions) {
            stockPanel.addStockGraph(createGraph(panelDefinitions.valueName, i, panelDefinitions.graphDefinitions[i]));
        }
        return stockPanel;
    }
    var createGraph = function (panelValueName, graphValueName, title) {
        var valueField = graphValueName + "_" +  panelValueName;
        var graph = new AmCharts.StockGraph();
        graph.title = title;
        graph.id = valueField;
        graph.valueField = valueField;
        graph.type = "line";
        graph.lineThickness = 1.5;
        graph.comparable = true;
        graph.compareField = valueField;
        graph.compareGraphType = "line";
        graph.compareGraphLineThickness = 1.5;
        return graph;
    }
    var zoomToHour = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        $(this).blur();
    };
    var zoomToDay = function () {
        zoomOut();
        var startDate = _chart.startDate;
        var endDate = new Date(startDate.getTime() + 1 * 24 * 60 * 60 * 1000);
        _chart.zoom(startDate, endDate);
        $(this).blur();
    };
    var zoomMax = function () {
        zoomOut();
        $(this).blur();
    };

    var valueToString = function (value, unit) {
        if (value == null) return "-";
        if (value == 0) return value.toFixed(2) + " " + unit;

        var decimals = 2;
        if (value <= 0.1) var decimals = 3;

        if ((value >= Math.pow(10, 9))) return (value / Math.pow(10, 9)).toFixed(decimals) + " G" + unit;
        if ((value >= Math.pow(10, 6))) return (value / Math.pow(10, 6)).toFixed(decimals) + " M" + unit;
        if ((value >= Math.pow(10, 3))) return (value / Math.pow(10, 3)).toFixed(decimals) + " k" + unit;
        return value.toFixed(2) + " " + unit;
    }

    var recalculateTableEvent = function (event) {
        for (var rowIndex in _chart.dataSets) {
            var set = _chart.dataSets[rowIndex];

            var values = {};
            var valuesColumnIndex = {}
            for (var i in _stocks) {
                if (set.id in _stocks[i].graphDefinitions) {
                    values[_stocks[i].valueName] = {sum: 0, count: 0};
                }
                valuesColumnIndex[_stocks[i].valueName] = i;
            }

            for (var i in _stocks) {
                if (set.id in _stocks[i].graphDefinitions) {
                    var valueName = _stocks[i].valueName;
                    for (var p in set.dataProvider) {
                        var record = set.dataProvider[p];
                        if (record.date.getTime() < event.startDate.getTime() || record.date.getTime() > event.endDate.getTime())
                            continue;

                        if (!values[valueName].min && record[_stocks[i].valueName] != null)
                            values[valueName].min = record[_stocks[i].valueName];
                        if (!values[valueName].max && record[_stocks[i].valueName] != null)
                            values[valueName].max = record[_stocks[i].valueName];
                        if (record[_stocks[i].valueName] < values[valueName].min && record[_stocks[i].valueName] != null)
                            values[valueName].min = record[_stocks[i].valueName];
                        if (record[_stocks[i].valueName] > values[valueName].max && record[_stocks[i].valueName] != null)
                            values[valueName].max = record[_stocks[i].valueName];
                        if (record[_stocks[i].valueName] != null) {
                            values[valueName].sum = values[valueName].sum + record[_stocks[i].valueName];
                            values[valueName].count++;
                        }
                    }
                    values[valueName].avg = (values[valueName].sum / values[valueName].count);
                    if (!values[valueName].min) values[valueName].min =0;

                    var baseColumn = parseInt(valuesColumnIndex[valueName]) * 3 + 3;
                    var unit = "";

                    $("#"+ tableContainer + "-" + rowIndex + " td:nth-child(" + (baseColumn + 0) +")").text(valueToString(values[valueName].min, unit));
                    $("#"+ tableContainer + "-" + rowIndex + " td:nth-child(" + (baseColumn + 1) +")").text(valueToString(values[valueName].max, unit));
                    $("#"+ tableContainer + "-" + rowIndex + " td:nth-child(" + (baseColumn + 2) +")").text(valueToString(values[valueName].avg, unit));
                }
            }
        }
    };

    var prepareData = function (rawData, fieldMap, colors) {
        var dataSets = [];
        for (var i in rawData) {
            var set = rawData[i];
            var dataSet = new AmCharts.DataSet();
            dataSet.id = set.name,
                dataSet.title = set.title;
            dataSet.color = colors[i];
            dataSet.fieldMappings = createGraphFieldMap(fieldMap, set.name);
            dataSet.dataProvider = [];
            dataSet.compared = i === 0 ? false : true;
            dataSet.categoryField = "date";
            dataSets.push(dataSet);
        }

        for (var setIndex in rawData) {
            var set = rawData[setIndex];
            var dataProvider = [];
            for (var recordIndex in set.records) {
                var record = set.records[recordIndex];
                if (record === undefined || record === null ||record.timestamp === null) continue;
                var data = {};
                for (var fieldMapIndex in fieldMap) {
                    data[fieldMap[fieldMapIndex].fromField] = record[fieldMap[fieldMapIndex].fromField];
                }
                data.date = new Date(record.timestamp * 1000);
                dataProvider.push(data);
            }
            dataSets[setIndex].dataProvider = dataProvider;
        }
        return dataSets;

    };

    /* public */

    var refreshChart = function () {
        _chart.validateData();
    };
    var getChart = function () {
        return _chart;
    }

    var getContainer = function () {
        return _container;
    }

    var setRawData = function(rawData, fieldMap, colors) {
        setDataSets(prepareData(rawData, fieldMap, colors));
    }

    var setDataSets = function (dataSets) {
        _chart.dataSets = [];
        for (var dataSetIndex in dataSets) {
            _chart.dataSets.push(dataSets[dataSetIndex]);
        }
        _chart.validateData();
    }

    var createGraphFieldMap = function (basicMap, graphName) {
        var graphMap = [];
        for (var mapIndex in basicMap) {
            var map = {"fromField": basicMap[mapIndex].fromField, "toField": graphName + "_" + basicMap[mapIndex].toField};
            graphMap.push(map);
        }
        return graphMap;
    }

    /* construct */
    _chart = createChart();
    _chart.write(container);
    $("#" + container + "_zoomToHour").click(zoomToHour);
    $("#" + container + "_zoomToDay").click(zoomToDay);
    $("#" + container + "_zoomMax").click(zoomMax);

    if (tableContainer !== undefined && tableContainer !== "" && tableContainer !== null) {
        _chart.addListener("zoomed", recalculateTableEvent);
    }

    return {
        getChart: getChart,
        refreshChart: refreshChart,
        setRawData: setRawData,
        setDataSets: setDataSets,
        createGraphFieldMap: createGraphFieldMap,
        getContainer: getContainer
    };
};
